import { keyFactory, menuOrder } from "helpers/menuAccess_helper"
import React from "react"
import { Col, Form, Input, Row } from "reactstrap"

export default function MenuAccessBodyForm(props) {
  
  const availableKeys = menuOrder.filter(key => 
    props.menuAccessBody?.menu && props.menuAccessBody.menu.hasOwnProperty(key)
  );

  const half = Math.ceil(availableKeys.length / 2);
  const firstColumn = availableKeys.slice(0, half);
  const secondColumn = availableKeys.slice(half);

  const renderAccessItem = (key, index) => (
    <li key={key} style={{ listStyle: "none" }}>
      <Row className="align-items-center mb-2">
        <Col md="8">{keyFactory(key)}</Col>
        <Col md="4">
          <label className="custom-toggle custom-toggle-default mb-0">
            <input
              type="checkbox"
              checked={props.menuAccessBody.menu[key]}
              onChange={() => {
                props.setMenuAccessBody({
                  menu: {
                    ...props.menuAccessBody.menu,
                    [key]: !props.menuAccessBody.menu[key],
                  },
                })
              }}
            />
            <span
              className="custom-toggle-slider rounded-circle"
              data-label-off="Não"
              data-label-on="Sim"
            />
          </label>
        </Col>
      </Row>
    </li>
  );

  return (
    <Form className="needs-validation" noValidate autoComplete="off">
      <div className="form-row">
        <Col className="mb-3" xs="12" md="2">
          <label className="form-control-label" htmlFor="code">
            Código
          </label>
          <Input
            aria-describedby="inputGroupPrepend"
            id="code"
            type="text"
            value={props.menuAccessBody.code}
            readOnly={props.readOnly}
            disabled={props.saving || props.disableCode}
            valid={props.menuAccessBody.code !== ""}
            invalid={props.menuAccessBody.code === ""}
            onChange={(e) => {
              props.setMenuAccessBody({ code: e.target.value })
            }}
          />
          <div className="invalid-feedback">Código é obrigatório.</div>
        </Col>
        <Col className="mb-3" md="10">
          <label className="form-control-label" htmlFor="name">
            Nome
          </label>
          <Input
            aria-describedby="inputGroupPrepend"
            id="name"
            type="text"
            value={props.menuAccessBody.name}
            readOnly={props.readOnly}
            disabled={props.saving}
            valid={props.menuAccessBody.name !== ""}
            invalid={props.menuAccessBody.name === ""}
            onChange={(e) => {
              props.setMenuAccessBody({ name: e.target.value })
            }}
          />
          <div className="invalid-feedback">Nome é obrigatório.</div>
        </Col>
        <Col className="mb-3" md="12">
          <label className="form-control-label" htmlFor="accesses">
            Acessos
          </label>
          <ul style={{ fontSize: "14px", paddingLeft: 0 }}>
            <Row>
              <Col md="6">
                {firstColumn.map((key, index) => renderAccessItem(key, index))}
              </Col>
              <Col md="6">
                {secondColumn.map((key, index) => renderAccessItem(key, index))}
              </Col>
            </Row>
          </ul>
          <div className="invalid-feedback">Digite uma Descrição</div>
        </Col>
      </div>
    </Form>
  )
}